export default "__VITE_ASSET__6ee3b3b2__"